<template>
    <div>
        <h4 class="mb-2">Organization Information</h4>
        <input id="input-org-job" class="form-control" type="text" placeholder="Job Title" 
        v-model="job_title" :readonly="readonly" @input="handleInput" 
        :class="{'is-invalid' : invalid.includes('job_title')}"/>
        <label for="input-org-job" class="form-label">Job Title</label>
        
        <input id="input-org-orgname" class="form-control" type="text" placeholder="Organization Name" 
        v-model="org_name" :readonly="readonly" @input="handleInput" :required="orgNameRequired"  
        :class="{'is-invalid' : invalid.includes('org_name')}"/>
        <label for="input-org-orgname" class="form-label">Organization Name</label>

        <input id="input-org-building" class="form-control" type="text" placeholder="Building" 
        v-model="org_building" :readonly="readonly" @input="handleInput" 
        :class="{'is-invalid' : invalid.includes('org_building')}"/>
        <label for="input-org-building" class="form-label">Building</label>

        <input id="input-org-address" class="form-control" type="text" placeholder="Address" 
        v-model="org_address" :readonly="readonly" @input="handleInput" 
        :class="{'is-invalid' : invalid.includes('org_address')}"/>
        <label for="input-org-address" class="form-label">Address</label>
        
        <input id="input-org-city" class="form-control" type="text" placeholder="City" 
        v-model="org_city" :readonly="readonly" @input="handleInput" 
        :class="{'is-invalid' : invalid.includes('org_city')}"/>
        <label for="input-org-city" class="form-label">City</label>

        <div class="row">
            <fieldset class="col-md-8">
                <form-state v-model="org_state" :disabled="readonly" id="input-state"
                :class="{'is-invalid' : invalid.includes('org_state')}"></form-state>
                <label for="input-state" class="form-label">State</label>
            </fieldset>
        
            <fieldset class="col-md-4">
                <input id="input-zip" class="form-control" type="text" placeholder="Zip code" pattern="[0-9]{5}" 
                v-model="org_zip" :readonly="readonly" @input="handleInput" 
                :class="{'is-invalid' : invalid.includes('org_zip')}"/> 
                <label for="input-zip" class="form-label">Zip Code</label>
            </fieldset>
        </div>
        
        <div v-if="showGradeLevel">
            <select id="input-org-gradelevel" class="form-select" 
            v-model="grade_level" :disabled="readonly" @input="handleInput">
                <option value="0" selected>Not Applicable</option>
                <hr/>
                <option value="pk">Preschool</option>
                <option value="k">Kindergarten</option>
                <option value="1">Elementary (K-2)</option>
                <option value="2">Elementary (3-5)</option>
                <option value="3">Middle School (6-8)</option>
                <option value="4">High School (9-12)</option>
            </select>
            <label for="input-org-gradelevel" class="form-label">Grade Level</label>
        </div>
    </div>
</template>

<script>
import FormState from './FormState.vue';

export default {
    components: { FormState },

    props: {
        readonly: {
            type: Boolean,
            default: false,
        },

        invalid: {
            type: Array,
            default(data=[]) {
                return [];
            },
        },

        orgNameRequired: {
            type: Boolean,
            default: false
        },

        showGradeLevel: {
            type: Boolean,
            default: false,
        },

        value: {
            type: Object,
            required: true,
            default(data={}) {
                return {
                    job_title: data.job_title ?? '',
                    org_name: data.org_name ?? '',
                    org_building: data.org_building ?? '',
                    org_address: data.org_address ?? '',
                    org_city: data.org_city ?? '',
                    org_state: data.org_state ?? 'OH',
                    org_zip: data.org_zip ?? '',
                    grade_level: data.grade_level ?? 0,
                };
            }
        }
    },

    updated: function() {
        console.log('UPDATED!');
    },

    watch: {
        value: function(n, o) {
            this.job_title = n.job_title ?? '';
            this.org_name = n.org_name ?? '';
            this.org_building = n.org_building ?? '';
            this.org_address = n.org_address ?? '';
            this.org_city = n.org_city ?? '';
            this.org_state = n.org_state ?? '';
            this.org_zip = n.org_zip ?? '';
            this.grade_level = n.grade_level ?? '';
        },
    },

    data() {
        return {
            job_title: this.value.job_title,
            org_name: this.value.org_name,
            org_building: this.value.org_building,
            org_address: this.value.org_address,
            org_city: this.value.org_city,
            org_state: this.value.org_state,
            org_zip: this.value.org_zip,
            grade_level: this.value.grade_level,
        }
    },

    methods: {
        handleInput(event) {
            console.log('INPUT HANDLER');
            const data = {
                job_title: this.job_title,
                org_name: this.org_name,
                org_building: this.org_building,
                org_address: this.org_address,
                org_city: this.org_city,
                org_state: this.org_state,
                org_zip: this.org_zip,
                grade_level: this.grade_level,
            };

            this.$emit('input', data);
        },
    }
    
}
</script>